export default [
  {
    id: 1, 
    projectName: "Sky Grid",         // Project Name
    projectRole: "Worked Desk 1",    // Project Role
    activity: "50",
    currentRate: "55.00",
    totalHours: '6:18:00', 
    totalAmount: '0.00',
  },
  {
    id: 2, 
    projectName: "Peak Quest",
    projectRole: "Research Lead",
    activity: "50",
    currentRate: "55.00",
    totalHours: '0:09:23', 
    totalAmount: '0.00',
  },
   
];
